import React from 'react'

const Footer = () => {
    return (
        <div className='footer'>
           <div className='innerFooter'>
                Developed by <a target='blank' href="http://facebook.com/saadusufzai">Saad Aslam</a> | <a href="https://github.com/saadusufzai/Quiz-App-React--and-Typescrpt" target='blank'>GITHUB REPO</a>   
            </div> 
        </div>
    )
}

export default Footer
